const $ = jQuery.noConflict();

class Slider {
    constructor( selector, args = {} ) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        }
    }



    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
    }

    init() {
        if (!$(this.selector).not('.slick-initialized').length) {
            return;
        }
        let settings = this.getSlickSettings();
        $(this.selector).slick(settings);
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider');
const FluidSlider = new Slider(
    '.block-slider-gallery--hard .gallery-slider__slider-fluid',
    {
        centerMode: true,
        variableWidth: true,
    }
);
const FlexibleSlider = new Slider(
    '.block-slider-gallery--flexible .gallery-slider__slider-fluid',
    {
        centerMode: true,
        variableWidth: true,
		responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    }
);
const FeaturedMobileSlider = new Slider(
    '.program-overview-tabs',
    {
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
            breakpoint: 991,
            settings: "unslick"
        }],
    }
)

export { SimpleSlider, TestimonialSlider, FluidSlider, FlexibleSlider, FeaturedMobileSlider };
